import Copy from "@/components/copy";
import { useUser } from "@/zustand/store";
import QRCode from "react-qr-code";

const Account2FA = () => {
  const { user } = useUser((state) => state);
  return (
    <div>
      <header className="flex items-center justify-between">
        <div>
          <p className="text-lg">My Account</p>
          <p className="text-3xl leading-6 font-bold">
            Two Factor Authenticator
          </p>
        </div>
      </header>

      <p className="mt-8 text-base leading-4 font-medium lg:text-lg lg:leading-6">
        Google 2FA (Two-Factor Authentication) adds an extra layer of protection
        to your account by requiring a time-based code from your mobile device —
        helping keep your funds and data secure even if your password
        is compromised.
      </p>

      <div className="mt-4 flex gap-4">
        <div className="bg-primary-500 flex size-10 shrink-0 items-center justify-center rounded-full">
          <img
            src="/icons/download.svg"
            className="size-6"
            alt="download icon"
          />
        </div>

        <div>
          <h4 className="text-lg leading-5 font-semibold lg:text-xl">
            Download Authenticator
          </h4>
          <p className="text-primary-500/80 text-sm leading-6 lg:text-lg">
            Download an authenticator app such as Google Authenticator.
          </p>
          <div className="mt-6 flex gap-4">
            <div className="flex flex-col items-center gap-2 rounded-xl bg-white p-4 lg:h-48 lg:w-40">
              <QRCode
                className="h-full w-full"
                value={`https://apps.apple.com/us/app/google-authenticator/id388497605`}
              />
              <span className="text-primary-500/80 font-semibold">iOS</span>
            </div>
            <div className="flex flex-col items-center gap-2 rounded-xl bg-white p-4 lg:h-48 lg:w-40">
              <QRCode
                className="h-full w-full"
                value={`https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2`}
              />
              <span className="text-primary-500/80 font-semibold">Android</span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 flex gap-4">
        <div className="bg-primary-500 flex size-10 shrink-0 items-center justify-center rounded-full">
          <img src="/icons/scan.svg" className="size-6" alt="scan icon" />
        </div>

        <div>
          <h4 className="text-lg leading-5 font-semibold lg:text-xl">
            Scan QR code
          </h4>
          <p className="text-primary-500/80 text-sm leading-6 lg:text-lg">
            Download an authenticator app such as Google Authenticator.
          </p>

          <div className="mt-6 inline-flex size-40 gap-2 rounded-xl bg-white p-4">
            <QRCode
              className="h-full w-full"
              value={`otpauth://totp/${user?.email}?secret=${user?.authenticatorSecret}`}
            />
          </div>
          <div className="mt-6">
            <p className="text-sm font-semibold">
              Or manually enter the code below
            </p>
            <div className="flex items-center gap-2">
              <p className="text-primary-500/55 text-sm lg:text-lg">
                {user?.authenticatorSecret}
              </p>
              <Copy text={user?.authenticatorSecret} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account2FA;
